import React, { Component, Fragment } from 'react'
import { ApolloConsumer } from 'react-apollo'

import { USERNAME_QUERY } from '../../queries'

import { Container, Header, FormContainer, ButtonContainer, Feedback, Content } from './styles'
import { white, red, almostblack } from '../../styles/colors'

import Input from '../../components/Input/'
import Button from '../../components/Button/'

class ResetForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      loading: false,
      usernameValid: '',
      submitted: false,
      error: ''
    }

    this.checkForUsername = this.checkForUsername.bind(this)
  }

  componentDidMount() {
    this.timer = null
  }

  async checkForUsername() {
    if (this.state.username !== '') {
      const { data, loading } = await this.client.query({
        query: USERNAME_QUERY,
        variables: { username: this.state.username }
      })
      if (loading) {
        this.setState({ loading: true })
      }
      if (data) {
        this.setState({ loading: false })
      }
      if (data.usernameExists) {
        this.setState({ usernameValid: 'true' })
      } else {
        this.setState({ usernameValid: 'Gebruikersnaam onbekend' })
      }
    }
  }

  handleChange(e) {
    this.setState({ username: e.target.value, usernameValid: '' })
  }

  async handleSubmit(e) {
    e.preventDefault()
    await this.checkForUsername()
    if (this.state.usernameValid === 'true') {
      this.props.sendPasswordMail({
        variables: {
          data: {
            username: this.state.username
          }
        }
      })
    }
  }

  render() {
    
    return (
      <ApolloConsumer>
        {client => {
          this.client = client
          return (
            <Container>
              {this.props.data ? (
                <Fragment>
                  <Header>Bericht verzonden</Header>
                  <Content>Er is een e-mail verstuurd naar het bij ons bekende e-mailadres. Volg de instructies uit deze e-mail om uw wachtwoord opnieuw in te stellen. Mocht u geen e-mail hebben ontvangen, controleer dan uw spamfolder en neem anders <a href="https://kaarskoffie.nl/wachtwoord-vergeten">contact</a> met ons op.</Content>
                </Fragment>
              ) : (
                <Fragment>
                  <Header>Wachtwoord vergeten</Header>
                  <Content>Bent u uw wachtwoord vergeten? Vul hieronder uw gebruikersnaam in en we sturen u een e-mail met instructies naar het e-mailadres dat bij ons bekend is. Mocht u uw gebruikersnaam zijn vergeten, of lukt het opnieuw instellen van uw wachtwoord niet? Neem dan <a href="https://kaarskoffie.nl/wachtwoord-vergeten">contact</a> met ons op.</Content>
                  <FormContainer onSubmit={this.handleSubmit.bind(this)}>
                      <Input
                        value={this.state.username}
                        handleChange={this.handleChange.bind(this)}
                        name="username"
                        type="text"
                        placeholder="Gebruikersnaam"
                        icon="mail"
                        valid={this.state.usernameValid === 'true' ||  this.state.usernameValid === ''}
                      />
                      {this.state.usernameValid === '' || this.state.usernameValid === 'true' ? null : (
                        <Feedback>{this.state.usernameValid}</Feedback>
                      )}
                      {this.props.error !== '' ? (
                        <Feedback>{this.props.error}</Feedback>
                      ) : null}
                      {this.props.loading ? (
                        <Feedback>Laden...</Feedback>
                      ) : null}
                      <ButtonContainer>
                        <Button
                          background={red}
                          color={white}
                          radius="true"
                          hover={almostblack}
                          onSubmit={this.handleSubmit.bind(this)}
                        >
                          Verzenden
                        </Button>
                      </ButtonContainer>
                    </FormContainer>
                  
                  
                </Fragment>
              )}
            </Container>
          )
        }}
      </ApolloConsumer>
    )
  }
}

export default ResetForm



// WEBPACK FOOTER //
// ./src/containers/ResetForm/index.js